function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var RegisterUsernameTemplate = require('./register-username.template');
var SaitoOverlay = require('./../../../lib/saito/ui/saito-overlay/saito-overlay');
var SaitoLoader = require('./../../../lib/saito/ui/saito-loader/saito-loader');
var RegisterUsername = /*#__PURE__*/function () {
  function RegisterUsername(app, mod) {
    _classCallCheck(this, RegisterUsername);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.loader = new SaitoLoader(this.app, this.mod, '#register-username-template');
  }
  return _createClass(RegisterUsername, [{
    key: "render",
    value: function render() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.overlay.show(RegisterUsernameTemplate(this.app, this.mod, msg));
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _document$querySelect,
        _this = this;
      (_document$querySelect = document.querySelector('#saito-overlay-form-input')) === null || _document$querySelect === void 0 || _document$querySelect.select();
      document.getElementById('login').onclick = function (e) {
        _this.overlay.remove();
        _this.app.connection.emit('recovery-login-overlay-render-request');
        return;
      };
      document.querySelector('.saito-overlay-form-submit').onclick = function (e) {
        e.preventDefault();
        var identifier = document.querySelector('#saito-overlay-form-input').value;
        if (identifier) {
          var _this$mod$peers$;
          if (identifier.indexOf('@') > -1) {
            identifier = identifier.substring(0, identifier.indexOf('@'));
          }
          try {
            document.querySelector('.saito-overlay-form-header-title').innerHTML = 'Registering name...';
            document.querySelector('.saito-overlay-form-header-title').classList.add('saito-cached-loader', 'loading');
            document.querySelector('.saito-overlay-form-text').remove();
            document.querySelector('#saito-overlay-form-input').remove();
            document.querySelector('.saito-button-row').remove();
            _this.loader.render();
            _this.app.browser.addElementToId("<div class=\"saito-overlay-form-subtext\">Registration in process, please wait...</div>", 'register-username-template');
          } catch (err) {
            console.log(err);
          }
          var domain = '@saito';
          var data = {
            identifier: identifier + domain,
            request: 'registry namecheck'
          };
          var registry_peer_pk = ((_this$mod$peers$ = _this.mod.peers[0]) === null || _this$mod$peers$ === void 0 ? void 0 : _this$mod$peers$.publicKey) || null;
          _this.app.network.sendRequestAsTransaction('registry query', data, /*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(results) {
              var register_success, _t;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.p = _context.n) {
                  case 0:
                    if (!(results.length > 0)) {
                      _context.n = 1;
                      break;
                    }
                    salert('Identifier already in use. Please select another');
                    _this.render();
                    return _context.a(2);
                  case 1:
                    console.log('REGISTRY: name available, try to register');
                    _context.p = 2;
                    _context.n = 3;
                    return _this.mod.tryRegisterIdentifier(identifier, domain);
                  case 3:
                    register_success = _context.v;
                    if (register_success) {
                      console.log('REGISTRY: tx to register successfully sent');
                      //
                      // mark wallet that we have registered username
                      //
                      _this.app.keychain.addKey(_this.mod.publicKey, {
                        has_registered_username: true
                      });

                      // Change Saito-header / Settings page
                      _this.app.connection.emit('registry-update-identifier', _this.mod.publicKey);

                      //Fake responsiveness
                      setTimeout(function () {
                        _this.overlay.remove();
                      }, 3000);
                    } else {
                      salert('Error 411413: Error Registering Username');
                      _this.render();
                    }
                    _context.n = 5;
                    break;
                  case 4:
                    _context.p = 4;
                    _t = _context.v;
                    if (_t.message == 'Alphanumeric Characters only') {
                      salert('Error: Alphanumeric Characters only');
                    } else {
                      salert('Error: Error Registering Username');
                    }
                    _this.render();
                    console.error(_t);
                  case 5:
                    return _context.a(2);
                }
              }, _callee, null, [[2, 4]]);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }(), registry_peer_pk);
        }
      };
    }
  }]);
}();
module.exports = RegisterUsername;